/* eslint-disable array-callback-return */
/* eslint-disable no-param-reassign */
import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { Badge } from "reactstrap";
import CloseButton from "react-bootstrap/CloseButton";
import { handleErrors } from "../../services/handleErrors";
import { patchSubclientArea } from "../../services/areaServices";
import FiltroCentralizador from "./FiltroCentralizador";
import arraySorterer from "../../utils/sortArray";
import { useAuth } from "../../context/AuthContext";
import modulos from "../../mocks/modulos";

export const CentralizadorOptions = [
  {
    name: "Sucursal",
    color: "#00a9e0",
    type: 1,
  },
  {
    name: "Nóminas",
    color: "#43B02a",
    type: 2,
  },
  {
    name: "Facturación",
    color: "#ad1aac",
    type: 3,
  },
  {
    name: "Cobranzas",
    color: "#e35205",
    type: 4,
  },
];

function Centralizador({ row, reloadTable }) {
  const { currentUser } = useAuth();
  const isAdmin = currentUser && currentUser.haveAdminAccess(modulos.CLIENTES);
  const [badgeArray, setBadgeArray] = useState([]);
  const [modalFiltroCentralizador, setModalFiltroCentralizador] = useState(false);

  const fillBadgeCentralizador = (data) => {
    const dataArray = [data.areas];
    const newArray = [];
    dataArray[0].map((area) => {
      const matchedAreaData = CentralizadorOptions.find((opt) => {
        return opt.type === area.type;
      });
      area.color = matchedAreaData.color;
      area.name = matchedAreaData.name;
      newArray.push(area);
    });
    // eslint-disable-next-line no-nested-ternary
    setBadgeArray(arraySorterer(newArray, "type"));
  };

  const handleRemoveCentralizador = async (event) => {
    event.stopPropagation();
    const areaId = event.currentTarget.id;
    const centralizadoBody = { centralizado: false };
    try {
      await patchSubclientArea(areaId, centralizadoBody);
      toast.success("El área se descentralizó");
      reloadTable();
    } catch (error) {
      handleErrors(error);
      toast.error("El área no se logro centralizar.");
    }
  };

  useEffect(() => {
    fillBadgeCentralizador(row);
  }, [reloadTable]);

  useEffect(() => {
    fillBadgeCentralizador(row);
  }, []);
  return (
    <>
      {modalFiltroCentralizador ? (
        <FiltroCentralizador toggle={() => setModalFiltroCentralizador(!modalFiltroCentralizador)} centralizados={badgeArray} reloadTable={reloadTable} />
      ) : null}

      <span
        className="badge-container"
        onClick={(event) => {
          event.stopPropagation();
          if (isAdmin) {
            setModalFiltroCentralizador(!modalFiltroCentralizador);
          }
        }}
        onKeyPress={() => {}}
        role="button"
        tabIndex={-1}
        data-tag="allowRowEvents"
      >
        {badgeArray.map((badge) => {
          if (badge.centralizado) {
            return (
              <Badge tag="div" key={badge.id} className="badge-pills" style={{ backgroundColor: `${badge.color}`, padding: "0 4px", borderRadius: "8px" }}>
                {badge.name}
                {isAdmin && <CloseButton id={badge.id} className="badge-close-button" onClick={(event) => handleRemoveCentralizador(event)} data-tag="allowRowEvents" />}
              </Badge>
            );
          }
          return null;
        })}
      </span>
    </>
  );
}

export default Centralizador;
